import { ComingSoon } from './components/ComingSoon';
import { HeroSlider } from './components/HeroSlider';
import { PartnerForm } from './components/PartnerForm';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
import { UpcomingEvents } from './components/UpcomingEvents';

export function HomePage() {
  return (
    <div className="min-h-screen bg-page">
      <a
        href="#main-content"
        className="fixed left-4 top-4 z-[100] -translate-y-24 rounded-sm bg-card px-4 py-2 font-ui text-sm font-semibold text-fg-primary shadow-lg transition-transform focus:translate-y-0"
      >
        Skip to content
      </a>
      <SiteHeader />
      <main id="main-content">
        <HeroSlider />
        <UpcomingEvents />
        <ComingSoon />
        <PartnerForm />
      </main>
      <SiteFooter />
    </div>
  );
}
